import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@mhe/ngx-shared/popover";
const _c0 = ["tplPopover"];
function CopyrightComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 3);
    i0.ɵɵlistener("click", function CopyrightComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const _r3 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r3.toggle()); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", ctx_r0.classes)("mhePopover", _r1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.srOnlyPrompt);
} }
function CopyrightComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 8);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.creditText);
} }
/**
 * @deprecated since version 9.0
 */
export class CopyrightComponent {
    constructor() {
        this.creditText = '';
        this.srOnlyPrompt = 'Copyright Information';
    }
    get hasCreditText() {
        return this.creditText !== '';
    }
    get classes() {
        return {
            'dpg-icon-copyright': true,
            'has-copyright-text': this.hasCreditText,
        };
    }
}
CopyrightComponent.ɵfac = function CopyrightComponent_Factory(t) { return new (t || CopyrightComponent)(); };
CopyrightComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CopyrightComponent, selectors: [["mhe-copyright"]], viewQuery: function CopyrightComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { creditText: "creditText", srOnlyPrompt: "srOnlyPrompt" }, decls: 3, vars: 1, consts: [["panelClass", "copywrite-panel", 3, "ngClass", "mhePopover", "click", 4, "ngIf"], ["customPopover", ""], ["panelClass", "copywrite-panel", 3, "ngClass", "mhePopover", "click"], ["tplPopover", "mhePopover"], [1, "sr-only"], [1, "popover-header"], [1, "popover-custom-title"], [1, "popover-body"], [1, "popover-footer"]], template: function CopyrightComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CopyrightComponent_button_0_Template, 4, 3, "button", 0);
        i0.ɵɵtemplate(1, CopyrightComponent_ng_template_1_Template, 5, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.hasCreditText);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2.PopoverDirective], styles: ["[_nghost-%COMP%]{display:block;width:22px;height:22px}[_nghost-%COMP%]   button[_ngcontent-%COMP%], [_nghost-%COMP%]   span[_ngcontent-%COMP%]{background-color:#fff;opacity:.5;display:block;margin:0px auto;height:22px;width:22px;padding:2px;border:0px none}[_nghost-%COMP%]   button[_ngcontent-%COMP%]::before, [_nghost-%COMP%]   span[_ngcontent-%COMP%]::before{height:18px;width:18px;display:block}[_nghost-%COMP%]   button.has-copyright-text[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]:hover   button.has-copyright-text[_ngcontent-%COMP%], [_nghost-%COMP%]:active   button.has-copyright-text[_ngcontent-%COMP%]{opacity:1}#copyrightPopoverText[_ngcontent-%COMP%]{margin:-15px;white-space:nowrap}p[_ngcontent-%COMP%]{max-width:276px;text-align:center;margin:-5px}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyrightComponent, [{
        type: Component,
        args: [{ selector: 'mhe-copyright', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n  *ngIf=\"hasCreditText\"\n  [ngClass]=\"classes\"\n  [mhePopover]=\"customPopover\"\n  #tplPopover=\"mhePopover\"\n  panelClass=\"copywrite-panel\"\n  (click)=\"tplPopover.toggle()\"\n>\n  <span class=\"sr-only\">{{ srOnlyPrompt }}</span>\n</button>\n\n<ng-template #customPopover>\n  <div class=\"popover-header\">\n    <div class=\"popover-custom-title\"></div>\n  </div>\n  <div class=\"popover-body\">{{ creditText }}</div>\n  <div class=\"popover-footer\"></div>\n</ng-template>\n", styles: [":host{display:block;width:22px;height:22px}:host button,:host span{background-color:#fff;opacity:.5;display:block;margin:0px auto;height:22px;width:22px;padding:2px;border:0px none}:host button::before,:host span::before{height:18px;width:18px;display:block}:host button.has-copyright-text{cursor:pointer}:host:hover button.has-copyright-text,:host:active button.has-copyright-text{opacity:1}#copyrightPopoverText{margin:-15px;white-space:nowrap}p{max-width:276px;text-align:center;margin:-5px}/*# sourceMappingURL=copyright.component.css.map */\n"] }]
    }], null, { creditText: [{
            type: Input
        }], srOnlyPrompt: [{
            type: Input
        }], popover: [{
            type: ViewChild,
            args: ['tplPopover', { static: true }]
        }] }); })();
